import { render, staticRenderFns } from "./IndividualC.vue?vue&type=template&id=beafefd0&scoped=true"
import script from "./IndividualC.vue?vue&type=script&lang=js"
export * from "./IndividualC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beafefd0",
  null
  
)

export default component.exports